import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

addToChainAfter(chain, PopulateApiParameter, props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: state.fieldValues["message"],
        emailTo: state.fieldValues["topicEmailAddress"],
    };
   
});



